module.exports = __webpack_public_path__ + "media/images/icon__whatsapp-bc4da4a424bed0761470a2e1ffd3894e.png";